import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import getFlattenedConfiguration from './selectors/getFlattenedConfiguration';
import getPartByUid from './selectors/getPartByUid';
// import { has } from '../services/helper';

/**
 * Types and Action Creators
 */
const { Types, Creators } = createActions({
    setCaravan: ['caravan'],
    setModel: ['model'],
    setConfigurations: ['configurations'],
    setFormData: ['formData'],
    setUserData: ['userData'],
    updateFormData: ['fieldName', 'value'],
    updateConfiguration: ['category', 'value', 'parts', 'changedItem'],
    addMarkedDependency: ['partUid'],
    setRefreshing: ['refresh'],
});

export const ConfigTypes = Types;
export default Creators;

const additionalInitialState = global.additionalConfigurationState || {};
/**
 * Initial State
 */
export const INITIAL_STATE = Immutable({
    caravan: null,
    model: null,
    configurations: {
        engine: null,
        paintwork: null,
        interior: [],
        packs: [],
        basicvehicle: [],
        lastrada: [],
    },
    formData: {
        salutation: 'Herr',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        fax: '',
        street: '',
        zip: '',
        city: '',
        country: '',
        company: '',
        industry: '',
        date_of_birth: '',
        place_of_birth: '',
        id_number_place: '',
    },
    markedDependencies: [],
    userData: null,
    refreshing: false,
    ...additionalInitialState,
});

/**
 * Saves single caravan
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const setCaravan = (state, action) =>
    state.merge({ caravan: action.caravan });

/**
 * Saves single model
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const setModel = (state, action) =>
    state.merge({ model: action.model });

/**
 * Saves configurations
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const setConfigurations = (state, action) =>
    state.merge({ configurations: action.configurations });

/**
 * Sets the form data
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const setFormData = (state, action) =>
    state.merge({ formData: action.formData });


/**
 * Saves user data
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const setUserData = (state, action) =>
    state.merge({ userData: action.userData });

/**
 * Updates a single form field
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const updateFormData = (state, action) => {
    const { fieldName, value } = action;
    const oldFormData = state.formData;

    return state.merge({
        formData: {
            ...oldFormData,
            [fieldName]: value,
        },
    });
};

const checkDependsOn = (part, flatSelectedConfigurationParts) => {
    const dependsOns = part.depends_on;
    if (dependsOns.length === 0) return true;
    let result = true;
    dependsOns.forEach((dependsOn) => {
        const filteredSelectedParts = flatSelectedConfigurationParts.filter(
            (selectedPart) => selectedPart.uid === dependsOn);
        result = result && (filteredSelectedParts.length > 0);
    });
    return result;
};


const checkExclude = (part, flatSelectedConfigurationParts) => {
    const excludes = part.exclude;
    if (excludes.length === 0) return true;
    let result = true;
    excludes.forEach((exclude) => {
        const filteredSelectedParts = flatSelectedConfigurationParts.filter(
            (selectedPart) => selectedPart.uid === exclude);
        result = result && (filteredSelectedParts.length === 0);
    });
    return result;
};

const checkExclusiveOr = (part, flatSelectedConfigurationParts) => {
    const exclusiveOrs = part.exclusive_or;
    if (exclusiveOrs.length === 0) return true;
    let result = false;
    exclusiveOrs.forEach((exclusiveOr) => {
        const filteredSelectedParts = flatSelectedConfigurationParts.filter(
            (selectedPart) => selectedPart.uid === exclusiveOr);
        result = result || (filteredSelectedParts.length > 0);
    });
    return result;
};

const getSerialInclusives = (currentCategory, parts) => {
  if (currentCategory === 0) { return currentCategory; }
  const currentCategoryParts = Array.isArray(currentCategory) ? currentCategory : [currentCategory];
  const partsWithSerialInclusives =
    currentCategoryParts.filter((part) => part.serial_inclusive.length > 0);

  let serialParts = [];
  partsWithSerialInclusives.forEach((partWithSerialInclusives) => {
    const parentUid = partWithSerialInclusives.uid;
    const additionalSerialParts =
      partWithSerialInclusives.serial_inclusive.map((partUid) => {
      const serialPart = getPartByUid(partUid, parts);
      serialPart.serial_parent_uid = parentUid;
      return serialPart;
    });
    serialParts = serialParts.concat(additionalSerialParts);
  });
  return serialParts;
};

const getSerialInclusives2 = (currentCategory, parts) => {
  if (currentCategory === 0) { return currentCategory; }
  const currentCategoryParts = Array.isArray(currentCategory) ? currentCategory : [currentCategory];
  const partsWithSerialInclusives =
    currentCategoryParts.filter((part) => part.serial_inclusive2 &&
      part.serial_inclusive2.length > 0);

  let serialParts = [];
  partsWithSerialInclusives.forEach((partWithSerialInclusives) => {
      const additionalSerialParts =
          partWithSerialInclusives.serial_inclusive2.map((partUid) => {
              const serialPart = getPartByUid(partUid, parts);
              return serialPart;
          });
      serialParts = serialParts.concat(additionalSerialParts);
  });
  return serialParts;
};

const removeSerialPartsWithoutParent = (selectedParts) => {
  const keys = Object.keys(selectedParts);
  const flattenedConfiguration = getFlattenedConfiguration(selectedParts);
  const filteredSelectedParts = { ...selectedParts };
  keys.forEach((key) => {
    switch (key) {
      case 'engine':
      case 'paintwork':
      case 'interior': {
        break;
      }
      default: {
        if (selectedParts[key]) {
          filteredSelectedParts[key] = selectedParts[key].filter((currentPart) => {
            if (currentPart.serial_parent_uid) {
              const foundSelectedPart = flattenedConfiguration.filter(
                (selectedPart) => selectedPart.uid === currentPart.serial_parent_uid
              );
              if (foundSelectedPart.length === 0) {
                if (!currentPart.mandatory) {
                  return false;
                }
              }
            }
            return true;
          });
        }
      }
    }
  });
  return filteredSelectedParts;
};

const addInclusiveParts = (input, inclusivePartsList) => {
  let result = { ...input };
  inclusivePartsList.forEach((part) => {
    const { uid, scene } = part;
    switch (scene) {
      case 'engine':
      case 'paintwork':
      case 'interior': {
        result[scene] = input[scene];
        break;
      }
      default: {
        result[scene] = [...(result[scene].filter((scenePart) => scenePart.uid !== uid)), part];
      }
    }
  });

  result = removeSerialPartsWithoutParent(result);

  return result;
};

/**
 * Updates single configuration by given type and value.
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const updateConfiguration = (state, action) => {
    const { category, value, parts, changedItem } = action;
    if (changedItem === undefined && Array.isArray(parts)) {
        return state;
    }
    const oldConfig = { ...state.configurations };
    const flatSelectedConfigurationParts = [
        ...getFlattenedConfiguration(oldConfig, category),
        ...(Array.isArray(value) ? value : [value]),
    ];
    let result = {};
    let inclusivePartsList = [];
    Object.keys(oldConfig).forEach((key) => {
        if (key === category) return;
        let currentCategory = oldConfig[key];
        switch (key) {
            case 'engine':
            case 'paintwork':
                break;
            default:
                currentCategory = currentCategory.filter((part) =>
                    checkDependsOn(part, flatSelectedConfigurationParts)
                    && checkExclude(part, flatSelectedConfigurationParts)
                    && checkExclusiveOr(part, flatSelectedConfigurationParts)
                );
                inclusivePartsList = inclusivePartsList.concat(getSerialInclusives(value, parts));
                inclusivePartsList = inclusivePartsList.concat(getSerialInclusives2(value, parts));
        }
        result[key] = currentCategory;
    });
    result = addInclusiveParts({ ...result, [category]: value }, inclusivePartsList);

    // Remove selected part from marked list
    const oldMarkedDependencies = [...state.markedDependencies];
    if (changedItem) {
      if (changedItem.uid) {
        const indexOfValue = oldMarkedDependencies.indexOf(changedItem.uid);
          if (indexOfValue > -1) {
              oldMarkedDependencies.splice(indexOfValue, 1);
          }
      } else {
        for (let i = 0; i < changedItem.length; i += 1) {
          const indexOfValue = oldMarkedDependencies.indexOf(changedItem[i].uid);
          if (indexOfValue > -1) {
              oldMarkedDependencies.splice(indexOfValue, 1);
          }
        }
      }
    }

    return state.merge({
        configurations: {
            ...result,
        },
        markedDependencies: [...oldMarkedDependencies],
    });
};

export const addMarkedDependency = (state, action) => {
  const oldMarkedDependencies = [...state.markedDependencies];
  if (oldMarkedDependencies.indexOf(action.partUid) === -1) {
    oldMarkedDependencies.push(action.partUid);
  }
  return state.merge({
    markedDependencies: [...oldMarkedDependencies],
  });
};

/**
 * Setting Refreshing
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const setRefreshing = (state, action) => {
    if (!action.refresh) {
        return state.merge({
            refreshing: action.refresh,
        });
    }
    return state.merge({
        configurations: INITIAL_STATE.configurations,
        refreshing: action.refresh,
    });
};

/**
 *  Hookup Reducers To Types
 */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_CARAVAN]: setCaravan,
    [Types.SET_MODEL]: setModel,
    [Types.SET_CONFIGURATIONS]: setConfigurations,
    [Types.SET_FORM_DATA]: setFormData,
    [Types.SET_USER_DATA]: setUserData,
    [Types.UPDATE_FORM_DATA]: updateFormData,
    [Types.UPDATE_CONFIGURATION]: updateConfiguration,
    [Types.ADD_MARKED_DEPENDENCY]: addMarkedDependency,
    [Types.SET_REFRESHING]: setRefreshing,
});
